import React, { useEffect, useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_BASE_URL } from "../../config.js";
import Pagination from "../Pagination/Paginations.js";
import DownloadButtons from "../DownloadButtons/DownloadButtons.js";
import EntriesSelector from "../Pagination/EntriesSelector";
import "../preloading.css";
import Select from 'react-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const EarlyReport = () => {
  const today = new Date().toISOString().split("T")[0];

  const [filters, setFilters] = useState({
    start_date: today,
    end_date: today,
    dept_id: "0",
    action_type: "Fetch",
  });

  const [departments, setDepartments] = useState([]);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);

  // ✅ Handle form input
  const handleInput = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  // ✅ Fetch department list
  const fetchDepartments = async () => {
    try {
      const res = await axios.get(API_BASE_URL + "/showdepartment", {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      });

      let deptData = [];
      if (Array.isArray(res.data)) {
        deptData = res.data;
      } else if (res.data.departments) {
        deptData = res.data.departments;
      } else if (res.data.data) {
        deptData = res.data.data;
      } else {
        toast.error("Unexpected response format from /showdepartment");
      }

      setDepartments(deptData);
    } catch (error) {
      console.error(error);
      toast.error("Failed to load departments");
    }
  };

  useEffect(() => {
    fetchDepartments();
  }, []);

  // ✅ Fetch Early Report
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await axios.post(
        API_BASE_URL + "/early_report", // 🔹 Laravel API endpoint
        {
          start_date: filters.start_date,
          end_date: filters.end_date,
          dept_id: filters.dept_id,
          action_type: filters.action_type,
        },
        { headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` } }
      );

      setRecords(res.data.records || []);
      setCurrentPage(1);
      toast.success("Early report loaded successfully!", {
        position: "bottom-right",
        theme: "colored",
      });
    } catch (error) {
      console.error(error);
      toast.error("Error fetching early report");
    } finally {
      setLoading(false);
    }
  };

  // ✅ Search + Pagination logic
  const filteredItems = records.filter((item) =>
    `${item.employee_id}${item.employee_name}${item.department}${item.shift_code}${item.attendance_date}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredItems.length / entriesPerPage);
  const indexOfLast = currentPage * entriesPerPage;
  const indexOfFirst = indexOfLast - entriesPerPage;
  const filteredData = filteredItems.slice(indexOfFirst, indexOfLast);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  return (
    <>
      <div className="container-fluid mt-4">
        <ToastContainer />

        {/* 🔹 Header Buttons */}
        <div className="mb-3 d-flex flex-wrap gap-2">
          <a href="/Early-going" className="btn btn-info btn-sm">
            Day Wise Early Going Report
          </a>
          <a href="/Weekly-going" className="btn btn-outline-secondary btn-sm">
            Weekly Wise Early Going
          </a>
          <a href="/Monthly-going" className="btn btn-outline-secondary btn-sm">
            Monthly Early Going
          </a>
        </div>

        {/* 🔹 Filter Form */}
        <div className="card shadow-sm mb-4">
          <div className="card-header with-elements">
            <span className="card-header-title me-2">Early Report Filter</span>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="row g-3 align-items-end">
                {/* From Date */}
              <div className="col-md-3">
  <label htmlFor="start_date">From Date</label>

  <DatePicker
    selected={filters.start_date ? new Date(filters.start_date) : null}
    onChange={(date) => {
      const value = date
        ? date.toLocaleDateString("en-CA")
        : "";

      setFilters((prev) => ({
        ...prev,
        start_date: value,
      }));
    }}
    dateFormat="yyyy-MM-dd"
    placeholderText="Select From Date"
    className="form-control"
    maxDate={filters.end_date ? new Date(filters.end_date) : null}
    required
  />
</div>

{/* To Date */}
<div className="col-md-3">
  <label htmlFor="end_date">To Date</label>

  <DatePicker
    selected={filters.end_date ? new Date(filters.end_date) : null}
    onChange={(date) => {
      const value = date
        ? date.toLocaleDateString("en-CA")
        : "";

      setFilters((prev) => ({
        ...prev,
        end_date: value,
      }));
    }}
    dateFormat="yyyy-MM-dd"
    placeholderText="Select To Date"
    className="form-control"
    minDate={filters.start_date ? new Date(filters.start_date) : null}
    required
  />
</div>

                {/* Department */}
                <div className="col-md-3">
                  <label htmlFor="dept_id">Department</label>
                <Select
  name="dept_id"
  
  value={
    departments
      .map((dept) => ({
        value: dept.department_id || dept.id,
        label: dept.department_name,
      }))
      .find((d) => d.value === filters.dept_id) || null
  }
  onChange={(selected) =>
    handleInput({
      target: {
        name: "dept_id",
        value: selected ? selected.value : "",   // <-- FIXED
      },
    })
  }
  options={departments.map((dept) => ({
    value: dept.department_id || dept.id,
    label: dept.department_name,
  }))}
  isClearable
  placeholder="All Department"
  className="basic-single"
/>

                </div>

                {/* Submit */}
                <div className="col-md-2">
                  <button type="submit" className="btn btn-primary w-100">
                    Get
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>

        {/* 🔹 Table Section */}
        <div className="card">
          <div className="card-header">
            <h6 className="text-danger">Day Wise Early Going Report</h6>
          </div>

          <div className="card-body">
            {/* Top Controls */}
            <div className="d-flex justify-content-between mb-2 align-items-center">
              <div
                className="d-flex align-items-center gap-2"
                style={{ width: "auto", minWidth: "220px" }}
              >
                <DownloadButtons data={filteredItems} filename="Early_Going_Report" />
                <EntriesSelector
                  setEntriesPerPage={setEntriesPerPage}
                  setCurrentPage={setCurrentPage}
                  className="form-select form-select-sm"
                />
              </div>

              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Search..."
                style={{ width: "200px" }}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            {/* Table */}
            {loading ? (
              <div className="d-flex justify-content-center p-5">
                <div className="spinner"></div>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-bordered table-striped">
                  <thead style={{ backgroundColor: "#7d858369" }}>
                    <tr>
                      <th>Employee ID</th>
                      <th>Employee Name</th>
                      <th>Department</th>
                      <th>Shift Code</th>
                      <th>Punch In</th>
                      <th>Punch Out</th>
                      <th>Early Going Hours</th>
                      <th>Attendance Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData.length > 0 ? (
                      filteredData.map((row, idx) => (
                        <tr key={idx}>
                          <td>{row.employee_id}</td>
                          <td>{row.employee_name}</td>
                          <td>{row.department}</td>
                          <td>{row.shift_code}</td>
                          <td>{row.punch_in}</td>
                          <td>{row.punch_out}</td>
                          <td>{row.early_hours}</td>
                          <td>{row.attendance_date}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="8" className="text-center text-danger fw-bold">
                          No records found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}

            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default EarlyReport;
